var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('k-navigation'),_c('k-cart-button'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),(_vm.site && _vm.$route.name !== 'placeholder')?_c('k-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }